import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Loader, TextField } from "../../components";
import { Avatar, Col, Divider, Modal, Row, Table, Typography } from "antd";
import Header from "../../components/Layout/Header";
import { GamesActions, PrizePoolAction } from "../../store/actions";
import { IoIosInformationCircleOutline } from "react-icons/io";
import {
  FaCheckDouble,
  FaClock,
  FaEye,
  FaPen,
  FaRegQuestionCircle,
  FaSearch,
} from "react-icons/fa";
import { Images, Utils } from "../../config";
import moment from "moment";
import { Input } from "antd";
import { Actions } from "../../components/atoms/Actions";
import GameDetailsModal from "./molecules/GameDetailsModal";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { CustomButton } from "../../components/ui/button/CustomButton";

const PrizePool = () => {
  const dispatch = useDispatch();
  const data = useSelector((store) => {
    return store.PrizePoolReducer;
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [requiredUsers, setRequiredUsers] = useState(
    data?.gameDetail?.requiredUsers
  );

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsEditModalOpen(false);
  };

  useEffect(() => {
    dispatch(PrizePoolAction.GetPrizePool());
  }, []);

  const UpdatePrizeDetails = () => {
    if (requiredUsers % 100 === 0) {
      const dataUpdate = {
        id: data?.gameDetail?.id,
        requiredUsers: requiredUsers
          ? requiredUsers
          : data?.gameDetail?.requiredUsers,
      };
      dispatch(
        PrizePoolAction.UpdatePrizePool_Detail(dataUpdate, () => {
          dispatch(PrizePoolAction.GetPrizePool());
          Utils.showSnackBar({
            message: "Prize Pool Updated Successfully",
            severity: "success",
          });
          setIsEditModalOpen(false);
        })
      );
    } else {
      Utils.showSnackBar({
        message: "Please enter in multiples of 100",
        severity: "error",
      });
    }
  };

  const headerProps = {
    mainHeading: "Prize Pool Management",
    subHeading: ``,
  };

  const columns = [
    {
      title: "",
      dataIndex: "imageThumbUrl",
      key: "imageThumbUrl",
      width: "1%",
      render: (i, b) => <Avatar src={i} />,
    },
    {
      title: "Game Name",
      dataIndex: "name",
      key: "name",
      width: "2%",
    },
    {
      title: "Required Users in Pool",
      dataIndex: "requiredUsers",
      key: "requiredUsers",
      width: "5%",
    },
    {
      title: "Current User in Pool",
      dataIndex: "usersInCurrentPool",
      key: "usersInCurrentPool",
      width: "5%",
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      width: "5%",
      render: (a, b) => (
        <Row>
          <Col span={6}>
            <Actions.Button
              title={"Edit PrizePool Config"}
              icon={FaPen}
              sx={{
                bgcolor: "#eef7eb",
                color: "#54ac3f",
                // marginRight: "10px"
              }}
              onClick={() => {
                dispatch(
                  PrizePoolAction.GetPrizePool_Detail(a, () =>
                    setIsEditModalOpen(true)
                  )
                );
              }}
            />
          </Col>
          <Col span={6}>
            <Actions.Button
              title={"View PrizePool Details"}
              icon={FaEye}
              sx={{
                bgcolor: "#d9dcea",
              }}
              onClick={() => {
                dispatch(
                  PrizePoolAction.GetPrizePool_Detail(a, setIsModalOpen(true))
                );
              }}
            />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <>
      <Layout.DashboardHeader
        columnSpacing={5}
        customizeStyle={{
          display: "flex",
          padding: 25,
          backgroundColor: "#fffcfc",
          marginLeft: 2,
        }}
      >
        <Header headings={headerProps} />
        <div className="tbl_game">
          <Table
            dataSource={data?.games}
            columns={columns}
            pagination={false}
          />
          ;
        </div>
      </Layout.DashboardHeader>

      {/* View Modal  */}

      <Dialog
        open={isModalOpen && !data.loader}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          ".MuiPaper-root": {
            borderRadius: "10px",
            width: "min(100%, 500px)",
            margin: "1rem",
            py: 1,
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <Stack alignItems="center" spacing={2}>
            <Avatar
              shape="square"
              size={50}
              alt={data?.gameDetail?.name}
              sx={{ width: 100, height: 100 }}
              src={data?.gameDetail?.imageThumbUrl}
            />
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              {data?.gameDetail?.name || "Game Name"}
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={4} py={2}>
            <Stack spacing={1.5} sx={{ width: "100%" }}>
              <Row justify="space-around">
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Free Games Played:
                  </Typography>
                </Col>
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#000",
                      fontWeight: 600,
                      fontSize: "16px",
                      alignContent: "end",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    {data?.gameDetail?.freeGamesPlayed || 0}
                  </Typography>
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Required Users:
                  </Typography>
                </Col>
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#000",
                      fontWeight: 600,
                      fontSize: "16px",
                      alignContent: "end",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    {data?.gameDetail?.requiredUsers || "N/A"}
                  </Typography>
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Users in Current Pool:
                  </Typography>
                </Col>
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#000",
                      fontWeight: 600,
                      fontSize: "16px",
                      alignContent: "end",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    {data?.gameDetail?.usersInCurrentPool || 0}
                  </Typography>
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Total Coins Required:
                  </Typography>
                </Col>
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#000",
                      fontWeight: 600,
                      fontSize: "16px",
                      alignContent: "end",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    {data?.gameDetail?.totalCoinsRequired}
                  </Typography>
                </Col>
              </Row>
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions
          component={Stack}
          direction="row"
          width="100%"
          sx={{
            justifyContent: "center",
            pb: 2,
            gap: {
              sm: 1.25,
              xs: 1,
            },
          }}
        >
          <CustomButton
            sx={{
              flex: 1,
              maxWidth: "150px",
            }}
            onClick={() => setIsModalOpen(false)}
          >
            Done
          </CustomButton>
        </DialogActions>
      </Dialog>

      {/* Update Modal */}

      <Dialog
        open={isEditModalOpen}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          ".MuiPaper-root": {
            borderRadius: "10px",
            width: "min(100%, 500px)",
            margin: "1rem",
            py: 2,
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <Stack alignItems="center" spacing={2}>
            <Avatar
              shape="square"
              size={100}
              alt={data?.gameDetail?.name}
              sx={{ width: 100, height: 100 }}
              src={data?.gameDetail?.imageThumbUrl}
            />
            <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>
              {data?.gameDetail?.name || "Game Name"}
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={3} py={1}>
            <Stack spacing={1} sx={{ width: "100%" }}>
              <Row justify="space-around">
                <Col span={24}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    New Prizepool Amount:
                  </Typography>
                </Col>
                <Col span={24} style={{ justifyContent: "center" }}>
                  <Input
                    disabled
                    prefix={"£"}
                    value={requiredUsers}
                    defaultValue={data?.gameDetail?.requiredUsers}
                    style={{
                      width: "100%",
                      backgroundColor: "#f5f5f5",
                      border: "none",
                      padding: "10px 28px",
                      fontSize: "16px",
                    }}
                  />
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={24}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Minimum Users required:
                  </Typography>
                </Col>
                <Col span={24} style={{ justifyContent: "center" }}>
                  <Input
                    type="number"
                    defaultValue={data?.gameDetail?.requiredUsers}
                    style={{
                      width: "100%",
                      backgroundColor: "#f5f5f5",
                      border: "none",
                      padding: "10px 28px",
                      fontSize: "16px",
                    }}
                    onChange={(e) => setRequiredUsers(e.target.value)}
                  />
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={24}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Minimum Coins required:
                  </Typography>
                </Col>
                <Col span={24} style={{ justifyContent: "center" }}>
                  <Input
                    disabled
                    value={
                      requiredUsers
                        ? requiredUsers * 10
                        : data?.gameDetail?.totalCoinsRequired
                    }
                    defaultValue={
                      requiredUsers
                        ? requiredUsers * 10
                        : data?.gameDetail?.totalCoinsRequired
                    }
                    style={{
                      width: "100%",
                      backgroundColor: "#f5f5f5",
                      border: "none",
                      padding: "10px 28px",
                      fontSize: "16px",
                    }}
                  />
                </Col>
                <Col>
                  <Typography
                    style={{
                      marginTop: "10px",
                      color: "#FF0023",
                      fontWeight: 500,
                      fontSize: "14px",
                      marginRight: "2px",
                      display: "flex",
                      justifyContent: "between",
                      alignItems: "center",
                    }}
                  >
                    <IoIosInformationCircleOutline
                      size={20}
                      style={{
                        marginRight: "5px",
                      }}
                    />
                    Please ensure that the required users are in the multiples
                    of 100
                  </Typography>
                </Col>
              </Row>
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions
          component={Stack}
          direction="row"
          width="100%"
          sx={{ justifyContent: "center", pb: 2, gap: { sm: 1.25, xs: 1 } }}
        >
          <CustomButton
            variant="primary"
            sx={{ flex: 1, maxWidth: "150px" }}
            onClick={() => UpdatePrizeDetails()}
          >
            Update
          </CustomButton>
          <CustomButton
            variant="contained"
            sx={{
              border: "none",
              borderRadius: "10px",
              flex: 1,
              maxWidth: "150px",
              backgroundColor: "#425078",
              px: 3,
              py: 1.5,
            }}
            onClick={() => setIsEditModalOpen(false)}
          >
            Cancel
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default PrizePool;
